// DI   HVAC-008
function openPriceMatchModal() {
  document.getElementById('priceMatchModal').classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closePriceMatchModal(event) {
  if (!event || event.target === document.getElementById('priceMatchModal') || event.target.classList.contains('price-match-close')) {
    document.getElementById('priceMatchModal').classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Close modal with Escape key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closePriceMatchModal();
  }
});

// Handle form submission success redirect
document.addEventListener('DOMContentLoaded', function() {
  // If there's a success parameter, scroll to the success message
  if (window.location.search.includes('pmr=sent')) {
    const successMsg = document.querySelector('.price-match-success');
    if (successMsg) {
      successMsg.scrollIntoView({ behavior: 'smooth' });
    }
  }
  // Move the price match modal to be a direct child of <body>

  var modal = document.getElementById('priceMatchModal');
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
});
